import React from 'react'
import Banner from '../components/Banners'
import about from '../assets/about.png'
import { FaHouseTsunami } from "react-icons/fa6";
import HomeAparts from '../components/HomeAparts';
import Servicii from '../components/Servicii';
import FastLinks from '../components/FastLinks';
import { Helmet } from 'react-helmet-async';
import { organizationSchema } from '../lib/jsonLd';
import { useTr } from '../lib/i18n';
import { ruUrl } from '../lib/ru';

const Home = () => {
  const tr = useTr();
  const lang = tr('ro', 'ru');
  const roUrl = 'https://lvgimob.md/';
  const ruCanonical = ruUrl('/ru/');

  return (
    <>
      <Helmet>
        <title>{tr(
          'LVG Imob | Agenție imobiliară în Moldova – Apartamente, Case, Spații Comerciale și Terenuri',
          'LVG Imob | Агентство недвижимости в Молдове — квартиры, дома, коммерческие помещения и участки'
        )}</title>
        <meta name="description" content={tr(
          'LVG Imob – agenție imobiliară pentru apartamente, case, terenuri și spații comerciale în Republica Moldova. Descoperă oferte și programează o vizionare.',
          'Недвижимость в Молдове: квартиры, дома, участки и коммерческие помещения. Актуальные предложения LVG Imob в Унгенах, Кишинёве и Бельцах.'
        )} />
        <link rel="canonical" href={lang === 'ru' ? ruCanonical : roUrl} />
        <link rel="alternate" hreflang="ro" href={roUrl} />
        <link rel="alternate" hreflang="ru" href={ruCanonical} />
        <link rel="alternate" hreflang="x-default" href={roUrl} />
        <script type="application/ld+json">{JSON.stringify(organizationSchema())}</script>
      </Helmet>

      <section className='py-[60px] sm:py-[80px] px-[12px] flex flex-col gap-[40px] xl:gap-[80px] justify-between sm:container sm:mx-auto'>
        <Banner />

        <FastLinks />

        <div className="flex flex-col lg:flex-row gap-[40px] mt-[60px]">
          <div className="bg-red-100 p-[35px] xs:p-[50px] mx-auto rounded-[5px] w-full lg:w-2/5">
            <img src={about} alt="" className="w-full" loading="lazy" decoding="async" />
          </div>
          <div className="lg:px-[50px] justify-center rounded-[5px] w-full lg:w-3/5 flex flex-col gap-[30px]">
            <p className="text-[#d5ab63] uppercase font-[500] font-poppins tracking-wide text-[14px] sm:text-[18px]">{tr('Despre noi', 'О нас')}</p>
            <h2 className="font-[500] font-heading tracking-wide text-[28px] xs:text-[32px] sm:text-[40px]">
              {tr(
                'Fiecare proprietate are o poveste, iar misiunea noastră este să o conectăm cu persoana potrivită.',
                'У каждой недвижимости своя история, и наша миссия — связать её с подходящим человеком.'
              )}
            </h2>
            <div className="border-[1px] border-gray-300 rounded-[5px] p-[25px] flex flex-row gap-[20px] ">
              <div className=""><FaHouseTsunami className="text-[#d5ab63] text-[25px] xs:text-[30px] mt-[10px] xs:mt-0" /></div>
              <div className="flex flex-col gap-[10px]">
                <p className="font-poppins text-[18px] xs:text-[20px] font-[500]">{tr('Casa perfectă te așteaptă', 'Идеальный дом ждёт вас')}</p>
                <p className="font-body text-[13px] font-[500] text-gray-700">
                  {tr(
                    'Punem accent pe încredere, transparență și rezultate reale. Fie că ești proprietar și vrei să vinzi rapid, fie că ești în căutarea casei perfecte pentru familie, suntem alături de tine în fiecare etapă.',
                    'Мы делаем ставку на доверие, прозрачность и реальные результаты. Продаёте ли вы недвижимость или ищете идеальный дом для семьи — мы рядом на каждом этапе.'
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <HomeAparts />

      <Servicii />
    </>
  )
}

export default Home
